import { IconThemeTagLabelOutline } from "@/assets/icons/figma/IconThemeTagLabelOutline";
import { usePromotionCopy } from "@/features/promotions/hooks/usePromotionCopy";
import { InfoLabel } from "@/ui/cva/InfoLabel";

/**
 * Paid seller statement. The tooltip distinguishes it from platform curation.
 * The design-system label in Burst, Dark, Normal weight (Dieke, 2026-10-28), square and as tall
 * as the Boosted label, on cards, the PDP, My ads and ad details.
 */
export const PromotionPaidLabel = ({ text }: { text: string }) => {
  const { copy } = usePromotionCopy();
  return (
    <InfoLabel
      color="burst"
      variant="dark"
      size="small"
      corners="square"
      weight="normal"
      // Black, not the variant's white: white on burst-500 is 1.3:1 and unreadable.
      className="inline-flex whitespace-nowrap leading-6 text-black"
      title={copy("labelPaidNote")}
      data-testid="promotion-paid-label"
      leftIcon={
        <IconThemeTagLabelOutline className="size-4 shrink-0" aria-hidden />
      }
    >
      {/* An element child, not bare text: InfoLabel would wrap text in Flavor's 20px line height,
          and this label must be as tall as Boosted (24px line, Dieke 2026-10-27). */}
      <span className="font-title text-sm leading-6">{text}</span>
    </InfoLabel>
  );
};
